import { TripGrouping } from '../../lib/types/models/trip-grouping/trip-grouping'
import { IdsInput } from '../../lib/types/utils'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getTripGroupingsByTrips(ids: number[]) {
  if (ids.length === 0) return Promise.resolve([])
  return restApiClient
    .url(
      encodeNestedObject<IdsInput>(
        constructApiUrl(API.tripGroupings.getTripGroupingsByTrips.url, null),
        { ids }
      )
    )
    .get<TripGrouping[]>()
}
